import { withInstall } from '@park-ui/utils'

import Icon from './src/icon.vue'

export const ElIcon = withInstall(Icon)
export default ElIcon

export * from './src/icon'
